// extracted by mini-css-extract-plugin
export default {"myCard":"cards_myCard__YdLQX"};